import React from 'react';

import { criteriaStore } from 'stores/CriteriaStore';
import { standardsConversionFeetMeters, romanize } from 'utils/Utilities';
import standardsConfig from 'js/standards.config';

export class SiteInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = criteriaStore.getState();
    criteriaStore.listen(this.storeUpdated.bind(this));
  }

  storeUpdated() {
    this.setState(criteriaStore.getState());
  }

  render() {
    let elevation =
      this.state.elevation === 0 || this.state.elevation
        ? parseInt(standardsConversionFeetMeters(this.state.elevation, 'imperial', this.state.measurement))
        : null;
    let elevationLabel;
    let addressLabel;
    let standardLabel = 'ASCE/SEI ' + this.state.standardsVersion;
    let soilText = standardsConfig[this.state.standardsVersion].soilClassText[this.state.soilClass];

    if (
      this.state.elevation === 0 ||
      (this.state.elevation && elevation > -1000000 && this.state.elevationReferenceDatum)
    ) {
      elevationLabel =
        elevation +
        ' ' +
        (this.state.measurement === 'si' ? 'm' : 'ft') +
        ' with respect to ' +
        this.state.elevationReferenceDatum;
    } else {
      elevationLabel = (
        <span>
          Elevation service not available. Please contact USGS for accurate elevation in this area{' '}
          <a href='https://nationalmap.gov/elevation.html' target='_blank'>
            here.
          </a>
        </span>
      );
    }

    if (!this.state.streetAddress) {
      addressLabel = '';
    } else {
      addressLabel = this.state.streetAddress + ', ' + this.state.cityState + ', ' + this.state.postal;
    }

    return (
      <div className='report-container padding--small'>
        <div className='report-container__label'>
          <i
            id='leftPanelCloser'
            onClick={this.props.toggleLeftPanel.bind(this)}
            className='waves-effect waves-light material-icons hidden report-left-panel-close-override'
          >
            close
          </i>
          <div className='undo-report-container' onClick={this.props.undoReport.bind(this)}>
            <img src='app/images/return-arrow.svg' alt='back-button' className='report-undo-button'></img>
          </div>
        </div>
        <div className='report-container__label'>
          <h3>Location</h3>
          <address>{addressLabel}</address>
        </div>
        <div className='report-container__body white padding--small'>
          <table className='bordered'>
            <tbody>
              <tr>
                <td>Elevation</td>
                <td>{elevationLabel}</td>
              </tr>
              <tr>
                <td>Lat:</td>
                <td>{this.state.latitude}</td>
              </tr>
              <tr>
                <td>Long:</td>
                <td>{this.state.longitude}</td>
              </tr>
              <tr>
                <td>Standard:</td>
                <td>{standardLabel}</td>
              </tr>
              <tr>
                <td>Risk Category:</td>
                <td>{romanize(this.state.riskLevel)}</td>
              </tr>
              <tr>
                <td>Soil Class:</td>
                <td>{soilText}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
